import { useLocation, useParams } from "react-router-dom";

export const CheckoutStatusPage = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const status = query.get("status");
  const isSuccess = status === "success";

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-neutral-900 text-white">
      <h1 className="mb-5">
        {isSuccess ? "🎉 Payment Successful!" : "❌ Payment Canceled"}
      </h1>
      <div>
        {isSuccess
          ? "Thanks for your purchase. Your balance will be updated."
          : "You canceled the checkout. No payment was made."}
      </div>
      <p className="mt-5">You may close the window and return to the app.</p>
    </div>
  );
};
